import { render, staticRenderFns } from "./hotPort.vue?vue&type=template&id=22c73f9a&"
import script from "./hotPort.vue?vue&type=script&lang=js&"
export * from "./hotPort.vue?vue&type=script&lang=js&"
import style0 from "./hotPort.vue?vue&type=style&index=0&id=22c73f9a&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports